/* eslint-disable */
import { Configuration, LogLevel } from '@azure/msal-browser';
import { getAuthConfig } from '@Utils/getApiUrl';

const { clientId, tenantId } = getAuthConfig();

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  // system: {
  //   loggerOptions: {
  //     loggerCallback: (level, message, containsPii) => {
  //       if (!containsPii) {
  //         // eslint-disable-next-line
  //         console.info(`${level}: ${message}`);
  //       }
  //     },
  //     logLevel: LogLevel.Verbose,
  //   },
  // },
};
